import { render } from "./Footer.vue?vue&type=template&id=f4510752&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=f4510752&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Solstice-Web/Solstice-Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4510752"]])

export default __exports__